export default __webpack_public_path__ + "static/media/warning.fb95a303.svg";